import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl text-white">韩漫吧</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              致力于推荐好看韩国漫画，提供免费漫画大全和下拉式在线阅读服务。漫画同好分享与发现心仪作品的角落。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/romance" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">动作漫画</Link></li>
              <li><Link to="/category/drama" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">剧情漫画</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">悬疑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">联系与声明</h4>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-foreground-500"></i>
                <span>contact@hanmanba.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-foreground-500"></i>
                <span>本站所有漫画资源均来自网络</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-copyright-line mt-0.5 text-foreground-500"></i>
                <span>如有侵权请联系删除</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫吧 - 免费漫画大全. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}